import {match} from 'ts-pattern';

import {ascend, descend, sortWith} from 'ramda';

import {LeaderboardUser} from '@dms/api/settings';

import {getOperationGroupId} from './getOperationGroupId';

export const TOTAL_COLUMN_ID = 'total';

export type PayPerUseSortDirection = 'asc' | 'desc';

export interface PayPerUseLeaderboardSort {
  // `TOTAL_COLUMN_ID` or an operation-group id (shared label key / raw pair key).
  columnId: string;
  direction: PayPerUseSortDirection;
}

const getColumnValue =
  (columnId: string) =>
  (user: LeaderboardUser): number =>
    match(columnId)
      .with(TOTAL_COLUMN_ID, () => user.total)
      .otherwise((groupId) =>
        user.byOperationType
          .filter((operation) => getOperationGroupId(operation) === groupId)
          .reduce((sum, operation) => sum + operation.count, 0)
      );

/** Client-side sort by total or any operation-type column. */
export const sortLeaderboardUsers = (
  users: LeaderboardUser[],
  sort: PayPerUseLeaderboardSort
): LeaderboardUser[] => {
  const selector = getColumnValue(sort.columnId);
  const order = sort.direction === 'asc' ? ascend(selector) : descend(selector);

  return sortWith([order], users);
};
